import {
  SHOW_MODAL,
  HIDE_MODAL,
} from "./constants";
import { IModalState } from "./IModalState";
import { ModalActions, ModalShowAction } from "./actionTypes";

const defaultModalState: IModalState = {
  modalType: undefined,
};

export function modalReducer(state = defaultModalState, { type, ...action }: ModalActions): IModalState {
  switch (type) {
    case SHOW_MODAL: {
      const { payload: { modalType, modalProps } } = action as ModalShowAction;

      return ({
        modalType,
        modalProps,
      });
    }

    case HIDE_MODAL:
      return ({
        modalType: undefined,
      });

    default:
      return state;
  }
}
